// Homepage FAQ: <details data-faq-item> with a [data-faq-body] wrapper.
// Animates the answer height on open/close instead of the native instant toggle.
// [data-expanded] drives the minus/plus icon so it switches as soon as the click happens.
// Reduced motion: plain native toggle.

const DURATION = 320;
const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function setup(details) {
  if (details.dataset.faqReady) return;
  details.dataset.faqReady = '';
  const summary = details.querySelector('summary');
  const body = details.querySelector('[data-faq-body]');
  if (!summary || !body) return;
  if (details.open) details.dataset.expanded = '';
  let animation = null;

  const finish = (open) => {
    animation = null;
    details.open = open;
    body.style.height = '';
  };

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    const opening = !details.hasAttribute('data-expanded');
    if (opening) details.dataset.expanded = '';
    else delete details.dataset.expanded;

    if (reduceMotion()) {
      details.open = opening;
      return;
    }

    const start = animation ? body.getBoundingClientRect().height : (opening ? 0 : body.offsetHeight);
    if (animation) animation.cancel();
    if (opening) details.open = true;
    const end = opening ? body.scrollHeight : 0;

    const current = body.animate(
      [{ height: `${start}px`, opacity: opening ? 0.2 : 1 }, { height: `${end}px`, opacity: opening ? 1 : 0 }],
      { duration: DURATION, easing: EASING }
    );
    animation = current;
    current.onfinish = () => { if (animation === current) finish(opening); };
    current.oncancel = () => { if (animation === current) animation = null; };
  });
}

const init = (root = document) => root.querySelectorAll('details[data-faq-item]').forEach(setup);
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
